import * as React from "react";
const HtmlIcon = (props) => (
  <svg
  width={props?.size}
  height={props?.size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{"file_type_html"}</title>
    <polygon
      points="5.902 27.201 3.655 2 28.345 2 26.095 27.197 15.985 30 5.902 27.201"
      style={{
        fill: "#e44f26",
      }}
    />
    <polygon
      points="16 27.858 24.17 25.593 26.092 4.061 16 4.061 16 27.858"
      style={{
        fill: "#f1662a",
      }}
    />
    <polygon
      points="16 13.407 11.91 13.407 11.628 10.242 16 10.242 16 7.151 15.989 7.151 8.25 7.151 8.324 7.981 9.083 16.498 16 16.498 16 13.407"
      style={{
        fill: "#ebebeb",
      }}
    />
    <polygon
      points="16 21.434 15.986 21.438 12.544 20.509 12.324 18.044 10.651 18.044 9.221 18.044 9.654 22.896 15.986 24.654 16 24.65 16 21.434"
      style={{
        fill: "#ebebeb",
      }}
    />
    <polygon
      points="15.989 13.407 15.989 16.498 19.795 16.498 19.437 20.507 15.989 21.437 15.989 24.653 22.326 22.896 22.372 22.374 23.098 14.237 23.174 13.407 22.341 13.407 15.989 13.407"
      style={{
        fill: "#fff",
      }}
    />
    <polygon
      points="15.989 7.151 15.989 9.071 15.989 10.235 15.989 10.242 23.445 10.242 23.445 10.242 23.455 10.242 23.517 9.548 23.658 7.981 23.732 7.151 15.989 7.151"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default HtmlIcon;
